import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const markDeliveryOrderAsNotDelivered = async ({
  deliveryOrderId,
  isNotReceivedOrder,
}: {
  deliveryOrderId: string;
  isNotReceivedOrder: boolean;
}) => {
  const response = await mutationExecute({
    variables: {
      deliveryOrderId,
      isNotReceivedOrder,
    },
    mutation: graphql(`
      mutation MarkDeliveryOrderAsNotDelivered($deliveryOrderId: String!, $isNotReceivedOrder: Boolean!) {
        markDeliveryOrderAsNotDelivered(deliveryOrderId: $deliveryOrderId, isNotReceivedOrder: $isNotReceivedOrder) {
          id
          status
        }
      }
    `),
  });

  return response.data?.markDeliveryOrderAsNotDelivered ?? null;
};
